import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/reportes/reports";
import reports from "../../models/reportes/reports";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    reports: [],
    permissions: [],
    new: [],
    newPermission: {},
    edit: [],
    deleteItem: [],
    showAdd: false,
    scheduleId: null,
    openEmployee: false,
    mode: "",
    modeForm: "",
    openform: false,
    openDelete: false,
    itemsTable: [],
    modeParameters: "",
    execute: {},
    procedures: [],
    headers: [],
    rows: [],
    showTableExecute: false,
    visibleColumns: {},
    lookups: [],
    lookupDataMap: new Map(),
    executeParams: {},
  },

  mutations: {
    setReports(state, data) {
      state.reports = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setPermissions(state, data) {
      state.permissions = data;
    },
    setNewPermission(state, data) {
      state.newPermission = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setOpenform(state, data) {
      state.openform = data;
    },
    setModeForm(state, data) {
      state.modeForm = data;
    },
    setItemsTable(state, data) {
      state.itemsTable = data;
    },
    setModeParameters(state, data) {
      state.modeParameters = data;
    },
    setExecute(state, data) {
      state.execute = data;
    },
    setProcedures(state, data) {
      state.procedures = data;
    },
    setHeaders(state, data) {
      state.headers = data;
    },
    setRows(state, data) {
      state.rows = data;
    },
    setShowTableExecute(state, data) {
      state.showTableExecute = data;
    },
    setVisibleColumns(state, { columnName, isVisible }) {
      if (state.visibleColumns.hasOwnProperty(columnName)) {
        state.visibleColumns[columnName] = isVisible;
      } else {
        state.visibleColumns = {
          ...state.visibleColumns,
          [columnName]: isVisible,
        };
      }
    },
    setResetVisibleColumns(state) {
      const initialColumns = {};
      state.headers.forEach((header) => {
        initialColumns[header.value] = true;
      });
      state.visibleColumns = { ...initialColumns };
    },
    setLookups(state, data) {
      state.lookups = data;
    },
    setLookupData(state, { lookup, items }) {
      state.lookupDataMap.set(lookup, items);
    },
    setExeParams(state, data) {
      state.executeParams = data;
    },
  },
  actions: {
    async getReports(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getReports();
          state.commit("setReports", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getProcedures(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getProcedures();

          state.commit("setProcedures", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            let item = state.state.edit;
            let options = state.state.reports;

            options = options.map((option) => {
              if (option.id != item.id) {
                return option;
              }
              item = reports.fromJson({
                reporteId: item.id,
                nombre: item.name,
                descripcion: item.description,
                procedimiento: item.process,
                parametros: item.parameters,
                tipoRep: item.type,
                operId: item.operId,
                etiquetas: item.tags,
              });
              return item;
            });

            state.commit("setReports", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.reports;
            let newItem = reports.fromJson({
              reporteId: data.reporteId,
              nombre: item.name,
              descripcion: item.description,
              procedimiento: item.process,
              parametros: item.parameters,
              tipoRep: item.type,
              operId: item.operid,
              etiquetas: item.tags,
            });

            options.push(newItem);
            state.commit("setReports", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.reports;
            options = options.filter((option) => {
              return option.id != state.state.deleteItem.id;
            });
            state.commit("setReports", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async execute(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .execute(state.state.execute)
            .then(({ data }) => {
              let item = state.state.new;
              let newItem = reports.fromJson({
                operId: item.operid,
              });
              state.commit("setExecute", newItem);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async getLookups(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLookups();

          state.commit("setLookups", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getLookupData(state, lookup) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getLookupData(lookup);

          state.commit("setLookupData", { lookup: lookup, items: item });

          setTimeout(() => {
            resolve(true);
          }, 100);
        } catch (error) {
          reject(error);
        }
      });
    },
    // Permission
    async getReportPermissions({ state, commit }, id) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.service.getReportPermissions(id);
          commit("setPermissions", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async addPermission(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .addReportPermissions(state.state.newPermission)
            .then((data) => {
              let options = state.state.permissions;

              data.rolName = state.state.newPermission.rolName;
              options.push(data);
              state.commit("setPermissions", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async deletePermission(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteReportPermissions(state.state.deleteItem)
            .then(() => {
              let options = state.state.permissions;
              options = options.filter((option) => {
                return option.rolId != state.state.deleteItem.rolId;
              });
              state.commit("setPermissions", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
